import type { ComponentType } from 'react';

export function withModalMount<P extends { isOpen: boolean }>(Component: ComponentType<P>) {
  const MountedWhileOpen = (props: P) => (props.isOpen ? <Component {...props} /> : null);
  MountedWhileOpen.displayName = `withModalMount(${Component.displayName ?? Component.name ?? 'Component'})`;
  return MountedWhileOpen;
}
